import { combineReducers } from "redux";
import { reducer as simuladorPrevidencia } from "./simuladorPrevidencia";


const reducers = combineReducers({
    simuladorPrevidencia
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
